import { IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { Check } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { APICallStatus, ToDo, ToDoStatus } from "../../Types/UnitFeatureTypes";
import TaskDialog from "../CreateFeatures/TaskDialog";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../Redux/Reducer/ToDo";
import { updateToDoStatusAPIStatus } from "../../Redux/selectors";
import { useApp } from "../../context/appContext";

interface BuildToDoTableProps {
    item: ToDo[];
    showActions?: boolean;
}

const BuildToDoTable: React.FC<BuildToDoTableProps> = ({
    item,
    showActions = true
}) => {

    const dispatch = useDispatch();
    const [viewTask, setViewTask] = useState<number>(-1);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const completeTaskApiStatus = useSelector(updateToDoStatusAPIStatus);
    const {setSnackbar} = useApp();

    useEffect(() => {
        if (completeTaskApiStatus === APICallStatus.SUCCESS) {
            setSnackbar(true, 'Task Completed Successfully', 'success');
            dispatch(Actions.fetchToDo.toDoActions.request({offset: 0}));
        } else if (completeTaskApiStatus === APICallStatus.FAILURE) {
            setSnackbar(true, 'Failed Completed Task', 'error');
        }
        if (completeTaskApiStatus === APICallStatus.SUCCESS || completeTaskApiStatus === APICallStatus.FAILURE) {
            dispatch(Actions.todo.resetStatusRequestAction());
        }
    }, [completeTaskApiStatus]);

    const getTableData = (item: ToDo[]) => {
        return (<Table>
            <TableHead>
                <TableRow>
                    <TableCell sx={{fontWeight: 600}} align="center" >Created Date</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">Task Name</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center" >Due Date</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">Due Time</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">Priority</TableCell>
                    {showActions && <TableCell sx={{fontWeight: 600}} align="center">Actions</TableCell>}
                </TableRow>
            </TableHead>
            <TableBody>
                {item.map((todo: ToDo) =>
                    <>
                        <TaskDialog 
                            open={viewTask === todo.id} 
                            displayName="View Task" 
                            onCloseFunc={() => setViewTask(-1)}
                            actionOne={{label: "", color: "error", func: () => {}}}
                            actionTwo={{label: "Complete", color: "primary", func: () => todo.id !== undefined && handleCompleteTask(todo.id)}}
                            formData={todo}
                            setFormData={() => {}}
                            errors={errors}
                        />
                    <TableRow key={todo.id} sx={{
                        // borderLeftColor: todo.due_date > new Date() ? 'red' : todo.due_date > new Date(Date.now() - 86400000) ? 'orange' : 'green',
                        // borderLeftWidth: 5,
                        // borderLeftStyle: 'solid',
                        '&:hover': {
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer'
                    }}} onClick={(e) => {
                        if ((e.target as HTMLElement).closest('#actions')) return;
                        todo.id !== undefined && handleTaskExpanded(todo.id)
                    }}>
                        <TableCell align="center">{new Date(todo.created_on).toDateString()}</TableCell>
                        <TableCell sx={{maxWidth: 100}} align="center">
                            <Typography variant="body2" color="textSecondary" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {todo.title}
                            </Typography>
                        </TableCell>
                        <TableCell sx={{maxWidth: 400}} align="center">
                            <Tooltip title={new Date(todo.due_date).toDateString()}>
                                <Typography variant="body2" color="textSecondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {new Date(todo.due_date).toDateString()}
                                </Typography>
                            </Tooltip>
                        </TableCell>
                        <TableCell sx={{maxWidth: 400}} align="center">
                            <Tooltip title={new Date(todo.due_date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}>
                                <Typography variant="body2" color="textSecondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {new Date(todo.due_date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}
                                </Typography>
                            </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                            <Typography variant="body2" color="textSecondary" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {todo.priority}
                            </Typography>
                        </TableCell>
                        {showActions && (!todo.completed_on ? <TableCell align="center" id="actions">
                            <Tooltip title="Complete Task">
                                <IconButton onClick={() => todo.id !== undefined && handleCompleteTask(todo.id)}><Check /></IconButton> 
                            </Tooltip> 
                        </TableCell> : <TableCell align="center"/>)}
                    </TableRow>
                    </>
                )}
            </TableBody>
        </Table>)
    }
    
    if (!item.length) {
        return (
            <Paper elevation={3} sx={{borderRadius: 3, padding: 2, alignItems: 'center', display: 'flex', justifyContent: 'center'}}>
                <Typography variant="subtitle1" fontWeight={600} color="textSecondary">No Tasks Available</Typography>
            </Paper>
        )
    }

    const handleTaskExpanded = (id: number) => {
        setViewTask(id);
    }

    const handleCompleteTask = (id: number) => {
        dispatch(Actions.todo.updateTaskStatusRequestAction.request({id, status: ToDoStatus.COMPLETED}));
    }

    return (
        <Paper elevation={3} sx={{borderRadius: 3, overflow: 'auto'}}>
            {getTableData(item)}
        </Paper>
    )
}

export default BuildToDoTable;